<span
  [class.is-size-4]="big"
  [class.is-size-5]="normal"
  [class.is-size-m]="medium"
  [class.is-size-6]="tiny"
  [class.has-text-weight-normal]="!bold"
  [class.weight-medium]="bold"
  [class.is-capitalized]="capitalized"
>
  {{ title }}
</span>
